import { Suspense } from "react";
import { Outlet } from "react-router";

export function ElteLandingLayout() {
  return (
    <Suspense fallback={<div aria-busy="true" className="min-h-screen bg-white" />}>
      <Outlet />
    </Suspense>
  );
}
